document.addEventListener('DOMContentLoaded', function() {
  const countdownElements = document.querySelectorAll('[data-early-countdown]');
  
  countdownElements.forEach(function(element) {
    const countdownDate = element.getAttribute('data-countdown-date');
    
    if (!countdownDate) return;
    
    // Parse the countdown date and treat it as Amsterdam time
    // Format: YYYY-MM-DD HH:MM:SS
    const [datePart, timePart] = countdownDate.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = (timePart || '00:00:00').split(':');
    
    // Create a date object treating the input as Amsterdam time
    // We'll calculate the target timestamp by converting Amsterdam time to UTC
    const tempDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds || '00'}`);
    
    // Get the current offset for Amsterdam timezone at the target date
    const amsterdamTimeString = tempDate.toLocaleString('en-US', { 
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    // Calculate what the UTC timestamp should be for this Amsterdam time
    // by finding the difference between local interpretation and Amsterdam interpretation
    const localInterpretation = new Date(year, month - 1, day, hours, minutes, seconds || 0);
    const amsterdamNow = new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' });
    const localNow = new Date().toLocaleString('en-US');
    const offset = new Date(amsterdamNow).getTime() - new Date(localNow).getTime();
    
    const targetDate = localInterpretation.getTime() - offset;
    
    // Create timer structure
    element.innerHTML = `
      <div class="early-countdown-timer">
        <div class="early-countdown-item">
          <span class="early-countdown-value" data-days>00</span>
          <span class="early-countdown-label">D</span>
        </div>
        <div class="early-countdown-separator">:</div>
        <div class="early-countdown-item">
          <span class="early-countdown-value" data-hours>00</span>
          <span class="early-countdown-label">H</span>
        </div>
         <div class="early-countdown-separator">:</div>
        <div class="early-countdown-item">
          <span class="early-countdown-value" data-minutes>00</span>
          <span class="early-countdown-label">M</span>
        </div>
      </div>
    `;
    
    const daysEl = element.querySelector('[data-days]');
    const hoursEl = element.querySelector('[data-hours]');
    const minutesEl = element.querySelector('[data-minutes]');
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;
      
      if (distance < 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        return;
      }
      
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      
      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
    }
    
    // Initial update
    updateCountdown();
    
    // Update every minute
    setInterval(updateCountdown, 60000);
  });
});
